import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { actions } from '@common/redux/modules/Actions';
import { SCREEN, STATUS_TYPE } from '@common/Common';
import { CustomerAppState } from '../../../redux/modules/store';
import MailDeliveryUnsubscribed from '../../../component/templates/MailDeliveryUnsubscribed';
import { getMailDeliveryStopApi, MailDeliveryStopApiRequest, MailDeliveryStopApiResponse } from '@common/external/MailDeliveryStopApi';
import { MailDeliveryStopState } from '@common/redux/reducers/MailDeliveryStopReducer';


export async function getMailDeliveryStop(request: MailDeliveryStopApiRequest): Promise<MailDeliveryStopApiResponse> {
  const response: MailDeliveryStopApiResponse = await getMailDeliveryStopApi(request);
  return response;
}

const mapStateToProps = (appState: CustomerAppState) => {
  return {
    loginUser: appState.loginUser,
    header: {
      screenId: SCREEN.MAIL_STOP_DONE.ID,
      screenName: SCREEN.MAIL_STOP_DONE.NAME,
      statusType: STATUS_TYPE.NO_TYPE,
      loadingStatus: appState.loadingStatus.summary
    },
    result: appState.mailDeliveryStop.result,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    fetchMailDeliveryStop: (request: MailDeliveryStopApiRequest) => {
      updateMailDeliveryStopResult(request, dispatch);
    }
  };
};

/**
 * 最新情報を取得する
 * @param request
 * @param dispatch
 */

 export async function updateMailDeliveryStopResult(request: MailDeliveryStopApiRequest, dispatch: Dispatch ){
  return getMailDeliveryStop(request)
  .then((response) =>{
    if(response.resultStatus){
      const mailDeliveryStopState : MailDeliveryStopState =  {
        result: response.resultStatus,
      }
      dispatch(actions.fetchMailDeliveryStop(mailDeliveryStopState));
    }
    return response.resultStatus;
  }
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(MailDeliveryUnsubscribed);
